import { Flex } from "@mantine/core";
import React from "react";

const SimpleStampCheck: React.FC<{
  disabled?: boolean;
  toggled: boolean | null;
  toggle: (toggled: boolean | null) => void;
}> = ({ toggled, toggle, disabled = false }) => {
  return (
    <Flex align="center" gap="xxs">
      <Flex
        onClick={() => disabled === false && toggle(toggled === false ? null : false)}
        style={{
          color: "#fff",
          marginRight: "0.5rem",
          cursor: disabled === true ? "not-allowed" : "pointer",
          width: "25px",
          height: "25px",
          borderRadius: "50%",
          backgroundColor: toggled === false ? "var(--mantine-color-red-6)" : "#ccc",
          opacity: disabled === true ? 0.5 : 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <i className={`fa fa-close`} />
      </Flex>
      <Flex
        onClick={() => disabled === false && toggle(toggled === true ? null : true)}
        style={{
          color: "#fff",
          cursor: disabled === true ? "not-allowed" : "pointer",
          width: "25px",
          height: "25px",
          borderRadius: "50%",
          backgroundColor: toggled === true ? "var(--mantine-color-mc-primary-6)" : "#ccc",
          opacity: disabled === true ? 0.5 : 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <i className={`fa fa-check`} />
      </Flex>
    </Flex>
  );
};

export default SimpleStampCheck;
